import { create } from "zustand";

type CommentInputFocusedSlice = {
    inputFocused: boolean;
    setInputFocused: (value: boolean) => void;
};

export const useInputFocusedStore = create<CommentInputFocusedSlice>()(
    (set) => ({
        inputFocused: false,
        setInputFocused: (inputFocused) =>
            set({
                inputFocused,
            }),
    }),
);
